import { useState } from "react";
import { Flex } from "antd";
import _ from "lodash";

import { FIELD_KEYS, FIELD_LABELS, FIELD_ORDERS } from "constants/ErrorFields";
import { FILTER_KEYS, SORTER_KEYS } from "constants/table";
import AdvancedSearchButton from "components/Common/AdvancedSearchButton";
import AdvancedSearchModal from "components/ErrorList/AdvancedSearchModal";
import Pagination from "components/Common/Pagination";
import SearchBar from "components/Common/SearchBar";

// ##### Functions #####

const getFilterCount = (filters) => {
  return Object.entries(filters).reduce((acc, [key, val]) => {
    let filterCount = 0;

    if (key === FILTER_KEYS.SORTERS) {
      filterCount = Array.isArray(val)
        ? val.filter(
            (v) => !!v?.[SORTER_KEYS.SORT_BY] && !!v?.[SORTER_KEYS.SORT_ORDER]
          ).length
        : 0;
    } else if (
      ![
        FIELD_KEYS.ERROR_TYPE,
        FILTER_KEYS.PAGE,
        FILTER_KEYS.PAGE_SIZE,
        "products",
      ].includes(key)
    ) {
      const isFiltered =
        val !== null &&
        val !== undefined &&
        val !== "" &&
        (!Array.isArray(val) || val.length > 0);
      filterCount = isFiltered ? 1 : 0;
    }

    return acc + filterCount;
  }, 0);
};

const getSearchPlaceholder = (searchFields) => {
  return (
    "Search " +
    searchFields.reduce((acc, field, index) => {
      return acc + (index === 0 ? "" : ", ") + FIELD_LABELS[field];
    }, "")
  );
};

// ##### Component #####

const ErrorTableHeader = ({
  isHistoricalView,
  filters,
  tableDataTotalCount,
  loading,
  onFiltersChange,
}) => {
  const [showAdvancedSearchModal, setShowAdvancedSearchModal] = useState(false);
  const [searchBarKey, setSearchBarKey] = useState(1);
  const [prevFilters, setPrevFilters] = useState(filters);

  if (JSON.stringify(prevFilters) !== JSON.stringify(filters)) {
    setPrevFilters(filters);
    setSearchBarKey(searchBarKey + 1);
  }

  const searchFields = [FIELD_KEYS.ITEM_REF_NO];
  if (isHistoricalView) {
    searchFields.push(FIELD_KEYS.RESOLVER);
  }
  const searchPlaceholder = getSearchPlaceholder(
    _.intersection(FIELD_ORDERS, searchFields)
  );

  const filterCount = getFilterCount(filters);

  return (
    <>
      <Flex justify="space-between" gap="0.5rem 0" wrap="wrap">
        <Flex gap="small" wrap="wrap">
          <SearchBar
            key={searchBarKey}
            defaultValue={filters[FILTER_KEYS.SEARCH]}
            onSearch={(val) =>
              onFiltersChange({
                [FILTER_KEYS.SEARCH]: val,
              })
            }
            loading={loading}
            enableOnChange={true}
            placeholder={searchPlaceholder}
          />
          <AdvancedSearchButton
            filterCount={filterCount}
            loading={loading}
            onClick={() => setShowAdvancedSearchModal(true)}
          />
        </Flex>

        <Pagination
          currentPage={filters[FILTER_KEYS.PAGE]}
          currentPageSize={filters[FILTER_KEYS.PAGE_SIZE]}
          totalCount={tableDataTotalCount}
          loading={loading}
          onChange={(page, pageSize) => {
            onFiltersChange({
              [FILTER_KEYS.PAGE]: page,
              [FILTER_KEYS.PAGE_SIZE]: pageSize,
            });
          }}
        />
      </Flex>
      <AdvancedSearchModal
        isHistoricalView={isHistoricalView}
        showModal={showAdvancedSearchModal}
        filters={filters}
        searchPlaceholder={searchPlaceholder}
        onShowModalChange={setShowAdvancedSearchModal}
        onFiltersChange={onFiltersChange}
      />
    </>
  );
};

export default ErrorTableHeader;
